import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SelfThemerService } from "../lib-services/self-themer.service";

import { Theme } from "../models/colors";

@Component({
  selector: "lib-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"]
})
export class MenuComponent {
  @Input() options: Array<Theme>;
  @Output() themeChange: EventEmitter<Theme> = new EventEmitter<Theme>();

  constructor(public selftheme: SelfThemerService) {}

  changeTheme(themeToSet) {
    this.themeChange.emit(themeToSet);
  }
}
